import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const defaultDatetimeFormat = 'DD/MM/YYYY HH:mm:ss';

export const isValidDate = (date: string | number) => dayjs(date).isValid();

export const fromNow = (date: string) => dayjs(date).fromNow();

export const defaultFormat = (date: string) => dayjs(date).format(defaultDatetimeFormat);

export const formatDate = (date: number | undefined): string =>
  date ? dayjs(date).format('MMMM DD, YYYY') : '';

export const fullDateWithTimeZone = (date: string) =>
  dayjs(date).format('MMMM DD, YYYY [at] HH:mm:ss [GMT]Z');

/**
 * Formats a UTC ISO date string as "MMMM DD, YYYY" without converting to
 * local time.  Use this instead of formatDate() when the source value is a
 * UTC midnight timestamp (e.g. usageWindowStartDate) to avoid an off-by-one
 * date shift for UTC-negative users.
 */
export const formatDateUtc = (isoString: string): string =>
  dayjs.utc(isoString).format('MMMM DD, YYYY');
